import script from "./LinkView.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkView.vue?vue&type=script&setup=true&lang=js"

import "./LinkView.vue?vue&type=style&index=0&id=7fefbeb6&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fefbeb6"]])

export default __exports__